<template>
    <Card title="Etats du BP">
        <div
            v-for="(etat, index) in etats"
            :key="index"
            class="flex place-content-between pr-20 mb-4"
        >
            <span
                ><p>{{ etat[0] }}</p></span
            >
            <span
                class="bg-orange-300 flex justify-center content-center rounded-full w-10 max-h-6"
                ><p>{{ etat[1] }}</p></span
            >
        </div></Card
    >
</template>

<script>
import Card from "../card";
export default {
    components: {
        Card
    },
    props: {
        etats: {
            type: Map,
            required: true
        }
    }
};
</script>

<style></style>
